import SuperAGILiveChat from "./livechat_api.js";
import Utils from "./modules/utils.js";

(function() {
  const w = window;
  const existingInstance = w.SuperAGILiveChat;
  
  if (existingInstance && typeof existingInstance !== 'function' && existingInstance._q) {
    const queue = existingInstance._q;
    w.SuperAGILiveChat = SuperAGILiveChat;
    
    queue.forEach(args => {
      try {
        const method = args[0];
        const params = args.slice(1);
        if (typeof SuperAGILiveChat[method] === 'function') {
          SuperAGILiveChat[method].apply(SuperAGILiveChat, params);
        }
      } catch (error) {
        console.error('Error processing queued command:', error);
      }
    });
  } else {
    w.SuperAGILiveChat = SuperAGILiveChat;
  }
  
  function getWorkspaceId() {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].getAttribute('src');
      if (src && src.includes('livechat')) {
        const workspaceAttr = scripts[i].getAttribute('data-superagi-workspace');
        if (workspaceAttr) return workspaceAttr;
      }
    }
    return Utils.getWorkspaceId();
  }
  
  function processSettings() {
    if (!SuperAGILiveChat.isInitialized()) {
      const settings = w.SuperAGILiveChatSettings || {};
      const workspaceId = settings.workspace_id || getWorkspaceId();
      
      if (workspaceId) {
        const config = {
          w: workspaceId,
          u: settings.user_id || settings.external_id || null,
          e: settings.environment || null
        };
        
        const encryptedConfig = btoa(JSON.stringify(config));
        SuperAGILiveChat.init(encryptedConfig);
        
        const userData = {};
        if (settings.name) userData.name = settings.name;
        if (settings.email) userData.email = settings.email;
        if (settings.user_id || settings.external_id) {
          userData.external_id = settings.user_id || settings.external_id;
        }
        
        if (Object.keys(userData).length > 0) {
          SuperAGILiveChat.setUserData(userData);
        }
      }
    }
  }
  
  function autoInit() {
    const scripts = document.querySelectorAll('script[data-config]');
    let initializedWithConfig = false;
    
    scripts.forEach(script => {
      if (script.src && script.src.includes('livechat')) {
        const config = script.getAttribute('data-config');
        if (config && !SuperAGILiveChat.isInitialized()) {
          SuperAGILiveChat.init(config);
          initializedWithConfig = true;
        }
      }
    });
    
    if (initializedWithConfig) {
      const settings = w.SuperAGILiveChatSettings || {};
      const userData = {};
      if (settings.name) userData.name = settings.name;
      if (settings.email) userData.email = settings.email;
      if (settings.user_id || settings.external_id) {
        userData.external_id = settings.user_id || settings.external_id;
      }
      
      if (Object.keys(userData).length > 0) {
        SuperAGILiveChat.setUserData(userData);
      }
    } else {
      processSettings();
    }
  }
  
  w.SuperAGILiveChatInit = processSettings;
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    setTimeout(autoInit, 0);
  }
})();

export default SuperAGILiveChat;